module.exports = __webpack_public_path__ + "static/media/NFL_Ranking.af247500.PNG";